import _ from "lodash"; 
import { connect } from "react-redux";

import { fetchUserProfile } from "src/redux/actions/users";
import {fetchShareSection } from "src/legacy/redux/actions/conversationSection.jsx";
import { fetchAssetAnalytics, fetchSharesByOpportunityId } from "src/legacy/redux/actions/conversations";

import OpportunitySharesView from "./view";

const mapStateToProps = (state, ownProps) => {

  const shares = state.legacyRootReducer.conversations;
  const opportunityId = window.location.pathname.split('/')[3];

  return {
    id: opportunityId,
    location: window.location,
    currentPage: shares.pagination.current,
    totalPages: shares.pagination.totalPages,
    shares: shares.items,
    loadingShares: shares.loading,    
  };
};

const mapDispatchToProps = (dispatch) => {
  return {

    fetchUserProfile: () => {
      dispatch(fetchUserProfile());
    },

    fetchData: (id, page) => {
      return dispatch(fetchSharesByOpportunityId(id, page));
    },

    fetchShareSection: (shareId, sectionId) => {
      return dispatch(fetchShareSection(shareId, sectionId));
    },

    fetchAssetAnalytics: (shareID, sectionID, assetID) => {
      return dispatch(fetchAssetAnalytics(shareID, sectionID, assetID));
    },
  };
};

const OpportunitySharesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OpportunitySharesView);

export default OpportunitySharesContainer;